module.exports = __webpack_public_path__ + "img/Cube_qui_meurt.f8aad2b6.gif";